(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.factory('SynchronisationExtern', [SynchronisationsExternFn]);

    // sync model
    function SynchronisationsExternFn() {

        var SynchronisationExtern = function () {

            // default values
            this.id = 0;
            this.accessPassword = "",
                this.fK_User = null;
            this.guid = null;
            this.thirdParty = null;
            this.userDto = {};

            // vm
            this.vmThirdPary = null;
        };

        // extend
        SynchronisationExtern.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        };

        // prepare for save
        SynchronisationExtern.prototype.prepareForSave = function () {
            var self = this;

            self.thirdParty = self.vmThirdParty ? self.vmThirdParty.value : null;
            delete self.vmThirdPary;

            self.lastCheckDate = new Date();
            self.fK_User = self.userDto ? self.userDto.id : null;

            delete self.userDto; //remove relation
            delete self.vmEditable;
            delete self.vmIndex;
            delete self.vmNew;
        };

        return SynchronisationExtern;

    }
})();